import React, { useState } from "react";
import { FaSearch, FaCheck, FaPlus, FaUpload, FaDownload, FaTrash, FaEdit } from "react-icons/fa";

export default function Manufacturers() {
  const [search, setSearch] = useState("");
  const [published, setPublished] = useState("All");

  const data = [
    { id: 1, name: "Apple", published: true, order: 1 },
    { id: 2, name: "HP", published: true, order: 5 },
    { id: 3, name: "Nike", published: true, order: 5 },
  ];

  return (
    <div className="min-h-screen bg-gray-100 p-4 md:p-8">
      <h1 className="text-2xl md:text-3xl font-semibold text-gray-800 mb-6">Manufacturers</h1>

      {/* Action Buttons */}
      <div className="flex flex-wrap gap-3 justify-end mb-4">
        <button className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded">
          <FaPlus /> Add new
        </button>
        <button className="flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded">
          <FaDownload /> Export
        </button>
        <button className="flex items-center gap-2 bg-sky-600 hover:bg-sky-700 text-white px-4 py-2 rounded">
          <FaUpload /> Import
        </button>
        <button className="flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded">
          <FaTrash /> Delete selected
        </button>
      </div>

      {/* Search Section */}
      <div className="bg-white shadow-md rounded-lg p-4 mb-6">
        <h2 className="text-lg font-medium mb-4 flex items-center gap-2">
          <FaSearch className="text-gray-500" /> Search
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 items-center gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Manufacturer name
            </label>
            <input
              type="text"
              placeholder="Enter name"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="w-full border border-gray-300 rounded px-3 py-2 focus:ring-2 focus:ring-blue-400"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Published
            </label>
            <select
              value={published}
              onChange={(e) => setPublished(e.target.value)}
              className="w-full border border-gray-300 rounded px-3 py-2 focus:ring-2 focus:ring-blue-400"
            >
              <option>All</option>
              <option>Yes</option>
              <option>No</option>
            </select>
          </div>

          <div className="flex items-end">
            <button className="flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded w-full md:w-auto">
              <FaSearch /> Search
            </button>
          </div>
        </div>
      </div>

      {/* Table Section */}
      <div className="bg-white shadow-md rounded-lg p-4">
        <h2 className="text-base text-gray-600 mb-3">
          Learn more about <span className="font-semibold text-blue-600">manufacturers</span>
        </h2>

        <div className="overflow-x-auto">
          <table className="w-full border border-gray-200 text-sm">
            <thead>
              <tr className="bg-gray-50 text-left">
                <th className="p-3 border-b">
                  <input type="checkbox" className="w-4 h-4" />
                </th>
                <th className="p-3 border-b font-semibold">Name</th>
                <th className="p-3 border-b font-semibold">Published</th>
                <th className="p-3 border-b font-semibold">Display order</th>
                <th className="p-3 border-b font-semibold">Edit</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item) => (
                <tr key={item.id} className="odd:bg-white even:bg-gray-50 hover:bg-gray-100">
                  <td className="p-3 border-b">
                    <input type="checkbox" className="w-4 h-4" />
                  </td>
                  <td className="p-3 border-b">{item.name}</td>
                  <td className="p-3 border-b text-blue-600 text-center">
                    {item.published && <FaCheck className="inline" />}
                  </td>
                  <td className="p-3 border-b">{item.order}</td>
                  <td className="p-3 border-b">
                    <button className="flex items-center gap-2 bg-gray-100 hover:bg-gray-200 border border-gray-300 text-gray-700 px-3 py-1 rounded">
                      <FaEdit /> Edit
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="flex flex-wrap justify-between items-center text-sm text-gray-600 mt-4">
          <div className="flex items-center gap-2">
            Show
            <select className="border border-gray-300 rounded px-2 py-1">
              <option>15</option>
              <option>30</option>
              <option>50</option>
            </select>
            items
          </div>
          <div className="flex items-center gap-2 mt-2 md:mt-0">
            <button className="bg-gray-200 px-3 py-1 rounded hover:bg-gray-300">Previous</button>
            <button className="bg-blue-600 text-white px-3 py-1 rounded">1</button>
            <button className="bg-gray-200 px-3 py-1 rounded hover:bg-gray-300">Next</button>
          </div>
          <div>1-3 of 3 items</div>
        </div>
      </div>
    </div>
  );
}
